export const COLUMN_ID_MAP: Record<string, string> = {
  requestor_name: 'requestorName',
  requestor: 'requestorName',
  assignee_name: 'assigneeName',
  organization: 'organizationName',
} as const;

export const LAST_EDITED_DATE_FORMAT = 'MMM d, h:mm a';
